import { Component, OnInit, inject, signal } from "@angular/core";
import { MatSidenav } from "@angular/material/sidenav";
import { NavigationEnd, Router } from "@angular/router";
import { filter } from "rxjs/operators";
import { ChatbotView } from "@rrsolutionsit/atl-chatbot-lib";
import { ChatbotService } from "../shared/chatbot.service";
import { BootstrapService } from "../shared/bootstrap/bootstrap.service";

@Component({
    selector: "app-app-layout",
    templateUrl: "./app-layout.component.html",
    styleUrls: ["./app-layout.component.scss"],
    standalone: false,
})
export class AppLayoutComponent implements OnInit {
    protected readonly chatbotService = inject(ChatbotService);
    private readonly router = inject(Router);
    private readonly bootstrap = inject(BootstrapService);

    /** Hides the floating widget while on the dedicated `/ai` route. That route renders its
     *  own full screen instance of the widget, so the two must never be mounted at the same time. */
    protected readonly isChatbotRoute = signal(this.router.url.startsWith("/ai"));

    constructor() {
        this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
            this.isChatbotRoute.set(this.router.url.startsWith("/ai"));
        });
    }

    ngOnInit(): void {
        this.bootstrap.refresh();
    }

    /**
     * "Full screen" is the one View Picker choice that leaves the widget for a real route,
     * instead of switching in place like Sidebar/Floating do. It opens `/ai` in a **new
     * tab** rather than navigating the current one away, and is never persisted as the widget's
     * remembered view: it is a one-off action, not a steady state to restore into. The next time
     * the widget opens here it should come back as whatever the user had last chosen between
     * Floating and Sidebar, not reopen into `/ai`.
     */
    onChatViewChanged(view: ChatbotView): void {
        if (view === "fullscreen") {
            this.chatbotService.close();
            window.open("/ai", "_blank");
        } else {
            this.chatbotService.setView(view);
        }
    }
}
